import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { inject, Injectable } from '@angular/core';
import { authorizationFn } from "@softline/auth";
import { SOFTLINE_PERMISSION_DASHBOARD } from "../dashboard.shared";

@Injectable()
export class DashboardGuard {
  private readonly router = inject(Router);
  private readonly authorized = authorizationFn();

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.isAuthorized();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.isAuthorized();
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    return this.isAuthorized();
  }

  private isAuthorized(): boolean | UrlTree {
    return this.authorized(SOFTLINE_PERMISSION_DASHBOARD)()
      ? true
      : this.router.parseUrl('/');
  }
}
